// extracted by mini-css-extract-plugin
export default {"surgeryContainer":"SurgeryPage_surgeryContainer__KLFGz","surgeryForm":"SurgeryPage_surgeryForm__1WPq+"};